import classNames from "classnames";

import style from "./UserName.module.css";

interface UserNameProps {
  name: string;
}

export const UserName = ({ name }: UserNameProps) => {
  return (
    <div className={style.wrapper}>
      <div className={classNames([style.avatar])}>{[...name][0]}</div>
      {name}
    </div>
  );
};
